// @flow
import React from "react";
import moment from "moment";
import Highlighter from "react-highlight-words";
import { Button, LocaleLink, Status } from "../../../common";
import I18n from "../../../../i18n/I18n";
import styles from "../../../orders/orderBox/OrderBox.scss";

const OrderBox = (props: Object) => {
  const {
    data,
    transfersType,
    lang,
    searchString,
    printCall,
    exportAsn,
    isExportLoading,
    isPrintLoading,
    closeAsn,
    isClosing,
    seller,
    isFbn
  } = props;
  const diff = data && !data.is_match;
  return (
    <div className={styles.ctr}>
      <div className={styles.flexer}>
        <div className={styles.statusCtr}>
          {data && (data.asn_nr || data.partner_rtv_nr) ? (
            <LocaleLink
              to={`/transfers/${
                data.partner_rtv_nr
                  ? "rtv"
                  : `${
                      isFbn
                        ? data.status && data.status.toLowerCase() !== "closed"
                          ? "preview"
                          : "fbn-asn"
                        : "asn"
                    }`
              }/${data.asn_nr || data.partner_rtv_nr}`}
            >
              <Button variant="asn" className={styles.asnBtn}>
                <Highlighter
                  highlightClassName={styles.highlight}
                  searchWords={[searchString]}
                  autoEscape={true}
                  textToHighlight={data.asn_nr || data.partner_rtv_nr}
                />
              </Button>
            </LocaleLink>
          ) : (
            ""
          )}
        </div>
        {data.status ? (
          <div>
            <Status status={data.status} />
          </div>
        ) : (
          ""
        )}
      </div>
      <div className={styles.attrCtr}>
        {Number(data.qty_expected) >= 0 ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("transfers.expected-qty")}
            </h6>
            <div className={styles.attrVal}>
              <div className={`${styles.qty} ${diff ? styles.diff : ""}`}>
                {data.qty_expected}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {data.qty_sent >= 0 ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText(
                transfersType === 2
                  ? "transfers.items-sent-count"
                  : "transfers.picked-qty"
              )}
            </h6>
            <div className={styles.attrVal}>
              <div className={`${styles.qty} ${diff ? styles.diff : ""}`}>
                {data.qty_sent}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {data.qty_recv >= 0 ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("transfers.received-qty")}
            </h6>
            <div className={styles.attrVal}>
              <div className={`${styles.qty} ${diff ? styles.diff : ""}`}>
                {data.qty_recv}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {data.qty_approved >= 0 ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("transfers.approved")}
            </h6>
            <div className={styles.attrVal}>
              <div className={`${styles.qty}`}>{data.qty_approved}</div>
            </div>
          </div>
        ) : (
          ""
        )}
        {data.qty_rejected >= 0 ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("transfers.received-qty")}
            </h6>
            <div className={styles.attrVal}>
              <div
                className={`${styles.qty} ${
                  data.qty_rejected !== 0 ? styles.diff : ""
                }`}
              >
                {data.qty_rejected}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {data.qty_unidentified >= 0 ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("transfers.received-qty")}
            </h6>
            <div className={styles.attrVal}>
              <div
                className={`${styles.qty} ${
                  data.qty_unidentified !== 0 ? styles.diff : ""
                }`}
              >
                {data.qty_unidentified}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {data && data.picked_at ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("transfers.picked-at")}
            </h6>
            <div className={styles.attrVal}>
              {data && data.picked_at
                ? moment(data.picked_at).format(
                    `YYYY-MM-DD [${lang === "ar" ? "" : "at"}] h:mm:ss a`
                  )
                : "-"}
            </div>
          </div>
        ) : (
          ""
        )}

        {data && data.received_at ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("transfers.received-at")}
            </h6>
            <div className={styles.attrVal}>
              {data && data.received_at
                ? moment(data.received_at).format(
                    `YYYY-MM-DD [${lang === "ar" ? "" : "at"}] h:mm:ss a`
                  )
                : "-"}
            </div>
          </div>
        ) : (
          ""
        )}
        {data && data.shipped_at ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("transfers.shipped-at")}
            </h6>
            <div className={styles.attrVal}>
              {moment(data.shipped_at).format(
                `YYYY-MM-DD [${lang === "ar" ? "" : "at"}] h:mm:ss a`
              )}
            </div>
          </div>
        ) : (
          ""
        )}
        {data && data.scheduled_at ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("transfers.scheduled-table")}
            </h6>
            <div className={styles.attrVal}>
              {moment(data.scheduled_at).format(
                `YYYY-MM-DD [${lang === "ar" ? "" : "at"}] h:mm:ss a`
              )}
            </div>
          </div>
        ) : (
          ""
        )}
        {data && data.posted_at ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("transfers.closed-at")}
            </h6>
            <div className={styles.attrVal}>
              {moment(data.posted_at).format(
                `YYYY-MM-DD [${lang === "ar" ? "" : "at"}] h:mm:ss a`
              )}
            </div>
          </div>
        ) : (
          ""
        )}
        {data && data.warehouse_from ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("transfers.origin")}
            </h6>
            <div className={styles.attrVal}>{data.warehouse_from}</div>
          </div>
        ) : (
          ""
        )}
        {data && data.current_skunique ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("transfers.current-sku-u")}
            </h6>
            <div className={styles.attrVal}>{data.current_skunique}</div>
          </div>
        ) : (
          ""
        )}
        {data && data.incoming_skunique ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("transfers.incoming-sku-u")}
            </h6>
            <div className={styles.attrVal}>{data.incoming_skunique}</div>
          </div>
        ) : (
          ""
        )}
        {data && data.warehouse_to ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("transfers.destination")}
            </h6>
            <div className={styles.attrVal}>{data.warehouse_to}</div>
          </div>
        ) : (
          ""
        )}

        {data.zone_code ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("statement-details.finance-view-statement-type")}
            </h6>
            <div className={styles.attrVal}>{data.zone_code}</div>
          </div>
        ) : (
          ""
        )}
        {data.warehouse_code ? (
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText(
                transfersType === 2
                  ? "transfers.destination"
                  : "transfers.origin"
              )}
            </h6>
            <div className={styles.attrVal}>{data.warehouse_code || ""}</div>
          </div>
        ) : (
          ""
        )}
      </div>
      <div>
        <Button
          variant="dashed"
          className={styles.button}
          disabled={
            isPrintLoading ||
            (!data.partner_rtv_nr &&
              data.status !== "Complete" &&
              data.status !== "scheduled" &&
              data.status !== "closed")
          }
          onClick={() =>
            printCall(
              data.asn_nr || data.partner_rtv_nr,
              data.partner_rtv_nr ? "rtv" : null,
              isFbn ? "fbn" : null,
              data.status
            )
          }
        >
          {isPrintLoading &&
          isPrintLoading.indexOf(data.asn_nr || data.partner_rtv_nr) !== -1 ? (
            <div className={styles.loader} />
          ) : (
            I18n.getText("transfers.print")
          )}
        </Button>
        <Button
          variant="dashed"
          className={styles.button}
          disabled={
            isPrintLoading ||
            (!data.partner_rtv_nr &&
              data.status !== "Complete" &&
              data.status !== "scheduled" &&
              data.status !== "closed")
          }
          onClick={() =>
            exportAsn(
              data.asn_nr || data.partner_rtv_nr,
              data.partner_rtv_nr ? "rtv" : null,
              isFbn ? "fbn" : null,
              data.status
            )
          }
        >
          {isExportLoading &&
          isExportLoading.indexOf(data.asn_nr || data.partner_rtv_nr) !== -1 ? (
            <div className={styles.loader} />
          ) : (
            I18n.getText(
              data.partner_rtv_nr
                ? "transfers.export-rtv"
                : "statement.export-asn"
            )
          )}
        </Button>
        {data.status === "Open" &&
        transfersType !== 2 &&
        data.is_pickup_open &&
        seller.can_close_asn ? (
          <Button
            variant="secondary"
            className={styles.button}
            disabled={isClosing || data.status === "Complete"}
            onClick={() => closeAsn(data.id_partner_warehouse, data.id_asn)}
          >
            {isClosing && isClosing.indexOf(data.asn_nr) !== -1 ? (
              <div className={styles.loader} />
            ) : (
              I18n.getText("transfers.close-asn")
            )}
          </Button>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default OrderBox;



// WEBPACK FOOTER //
// ./src/components/transfers/transfersTable/transfersBox/TransfersBox.js